import React, {useState} from 'react'

import {noop} from 'es-toolkit'

import './_toast.scss'

import useTimeout from '../../hooks/use-timeout'
import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import alertCircleIcon from '../../assets/icons/alert-circle.svg'
import defaultIcon from '../../assets/icons/checked.svg'
import closeSmallIcon from '../../assets/icons/close-small.svg'

import Icon from '../icon'
import LoadingIndicator from '../loading-indicator'

const icons = {
  default: defaultIcon,
  warning: alertCircleIcon,
  error: alertCircleIcon,
}

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    onClose?: React.MouseEventHandler
    type?: 'default' | 'warning' | 'progress' | 'error'
    timeout?: number
    onTimeout?: () => void
  }
>

const Toast = ({
  className,
  children,
  type = 'default',
  onClose = noop,
  timeout = 0,
  onTimeout = noop,
  ...props
}: Props) => {
  const [timeoutActive, setTimeoutActive] = useState(!!timeout)
  useTimeout(timeout, timeoutActive, onTimeout)

  const handleMouseEnter = () => {
    setTimeoutActive(false)
  }

  const handleMouseLeave = () => {
    setTimeoutActive(true)
  }

  return (
    <div
      {...props}
      className={cn('Toast', {[`type-${type}`]: !!type}, className)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      <div className="Toast__icon">
        {type === 'progress' ? <LoadingIndicator /> : <Icon block source={icons[type]} />}
      </div>
      <button className="Toast__close" type="button" onClick={onClose}>
        <Icon block source={closeSmallIcon} />
      </button>
    </div>
  )
}

export default Toast
